import { SofReceivingOrder } from '../../../models/sof-receiving/SofReceivingOrder.interface';

/**
 * Collapses the queue to one card per SOF.
 *
 * The backing views (`SOF.ReceivingOrders` / `SOF.ReceivingOrdersHistory`) are
 * `SELECT DISTINCT` over a join of SOF.Orders → SOF.Items → MM.ReceivingLog, so
 * a single SOF returns one row per distinct (item-status × storage-facility)
 * combination. Once a SOF's POs are in mixed states (e.g. one PO In Progress,
 * another still Pending) the proc emits multiple rows for it.
 *
 * The duplicates differ only in fields the card doesn't render (item-level
 * `status`); the displayed chip uses the order-level `receivingStatus`, which is
 * identical across a SOF's rows. So keeping the first occurrence (the proc
 * already sorts them) is safe and loses nothing visible.
 *
 * @param orders - The rows as returned by the orders / history endpoint.
 * @returns One row per SOF, first occurrence kept, original order preserved.
 */
export function dedupeOrdersBySof(
  orders: SofReceivingOrder[]
): SofReceivingOrder[] {
  const seen = new Set<string>();
  const result: SofReceivingOrder[] = [];
  for (const order of orders) {
    if (!seen.has(order.sof)) {
      seen.add(order.sof);
      result.push(order);
    }
  }
  return result;
}
